export default "__VITE_ASSET__DqU0jjRL__"